module.exports = "/_next/static/images/main-visual-about@2x-4fbdc68a41f4efed610bf701b9acdb91.jpg";